<template>
  <div class="zj-form-container">
    <el-container>
      <zj-layout-main>
        <el-form
          ref="ChildBusinessform"
          status-icon
          :model="ChildBusinessform"
          :rules="rules"
          label-width="120px"
          class="ChildBusinessInfo"
          style="width: 90%;"
          v-loading="loading"
          :element-loading-text="loadingText"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="子商户编号" prop="ChildBusinessCode">
                <el-input
                  v-model.trim="ChildBusinessform.ChildBusinessCode" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="子商户名称" prop="ChildBusinessName">
                <el-input v-model.trim="ChildBusinessform.ChildBusinessName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="父商户" prop="BusinessCode">
                  <el-select  filterable placeholder="请选择"  v-model.trim="ChildBusinessform.BusinessCode" :disabled="IsUpdate">
                    <el-option
                      v-for="item in Businesses"
                      :key="item.BusinessCode"
                      :label="item.BusinessName"
                      :value="item.BusinessCode">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="子商户类型" prop="BusinessTypeId">
                  <el-select  filterable placeholder="请选择"  v-model.trim="ChildBusinessform.BusinessTypeId">
                    <el-option
                      v-for="item in BusinessTypes"
                      :key="item.BusinessTypeId"
                      :label="item.BusinessTypeName"
                      :value="item.BusinessTypeId">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系人" prop="ContactPerson">
                  <el-input v-model.trim="ChildBusinessform.ContactPerson"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="Phone">
                  <el-input v-model.trim="ChildBusinessform.Phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="8">
              <el-form-item label="所属景区" prop="ScenicUUID">
                  <el-select  filterable placeholder="请选择"  v-model.trim="ChildBusinessform.ScenicUUID">
                      <el-option
                        v-for="item in Scenics"
                        :key="item.ScenicUUID"
                        :label="item.ScenicName"
                        :value="item.ScenicUUID">
                      </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="经度" prop="Longitude">
                  <el-input v-model.trim="ChildBusinessform.Longitude"></el-input>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="纬度" prop="Latitude">
                  <el-input v-model.trim="ChildBusinessform.Latitude"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="地址" prop="Address">
                  <el-input v-model.trim="ChildBusinessform.Address"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="说明" prop="Remarks">
                  <el-input v-model.trim="ChildBusinessform.Remarks"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="是否启用" prop="BusinessState">
                   <el-switch 
                    active-value='1'
                    inactive-value='0'
                    v-model.trim="ChildBusinessform.BusinessState">
                  </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="音响编号" prop="Extends1">
                  <el-input v-model.trim="ChildBusinessform.Extends1"></el-input>
                  <el-button type="primary" @click="TestVideo">测试</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-footer style="text-align: center;">
        <el-button type="primary" v-if="IsFinish">提交审核</el-button>
        <el-button type="primary" @click="Onsubmit('ChildBusinessform')" v-if="IsEdit">提交</el-button>
        <el-button @click="OnCancel" v-if="IsEdit">取消</el-button>
      </el-footer>
    </el-container>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
</style>


<script>
import WebApis from "../../../apis";
import utils from "../../../../../../utils";
import { showLoading, hideLoading } from "../../../../../../loading";
import ZJApp from "../../../../../app";

export default {
  name: "ChildBusinessInfoPage",
  data() {
    return {
      ChildBusinessform: {
        ChildBusinessIcon :"",
        ScenicUUID:"",
        ChildBusinessCode :"",
        BusinessCode:"",
        BusinessTypeId:"",
        ChildBusinessName :"",
        ContactPerson :"",
        Phone :"",
        Remarks:"",
        Address :"",
        Longitude : "",
        Latitude : "",
        BusinessState : '1',
        Extends1:""
      },
      rules: {
        ScenicUUID:[
          { required: true, message: "请选择景区", trigger: "change" }
        ],
        ChildBusinessCode: [
          { required: true, message: "请输入子商户编号", trigger: "blur" }
        ],
        ChildBusinessName: [
          { required: true, message: "请输入子商户名称", trigger: "blur" }
        ],
        BusinessCode:[
           { required: true, message: "请选择父商户", trigger: "change" }
        ],
        BusinessTypeId: [
          { required: true, message: "请选择子商户类型", trigger: "change" }
        ],
        ContactPerson: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        Phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ]
      },
      resData: "",
      isPassed:"",
      Scenics:[],
      Businesses:[],
      SelectBusiness:"",
      loading: false,
      loadingText: "加载中...",
      uploadData: {
        module: "ChildBusinessManager", //模块名
        submodule: "", //子模块
        assocID: "", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      BusinessTypes:[],
      IsUpdate:false
    };
  },
  props: {
    ChildBusiness_Id: {
      type: String,
      default: "",
    },
    IsEdit: {
      type: Boolean,
      default: true,
    },
    IsFinish: {
      type: Boolean,
      default: true,
    },
  },
  created: function () {
    this.init();
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  methods: {
    // 初始化
    init() {
       return utils.waitAll([
            () => this.GetScenics(),
            ()=>this.GetBusiness(),
            ()=>this.GetChildBusinessType()
         ]).then(()=>{
            this.GetInfo();
          });
    },
    beforeupload: function (file) {

      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('上传头像图片只能是 JPG、PNG、GIF 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }

      
      this.loading = true;
      this.loadingText = "上传中... 0%";

      this.uploadData.assocID = this.uuid;

      this.loading = false;
      
      return isImage && isLt2M;
    },
    uploadsuccess: function (file) {
      this.ChildBusinessform.ChildBusinessIcon = file.DownloadPath;
      console.log("上传成功");
       this.$message({
            showClose: true,
            message: "上传成功!",
            type: "success",
          });
      this.loading = false;
      this.$refs["ChildBusinessform"].validateField('ChildBusinessIcon')
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    handlePreview(file) {
       console.log(file);
      // document.location.href = file.url;
    },
    Onsubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    OnReview(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.SaveData();
        } else {
          this.$message({
            showClose: true,
            message: "填写内容不正确!",
            type: "error",
          });
          return false;
        }
      });
    },
    TestVideo()
    {
      if(this.ChildBusinessform.Extends1=="")
      {
        this.$message({
            showClose: true,
            message: "请输入音箱编号!",
            type: "error",
          });
          return false;
      }

      let Test_Video={
        dev_no:this.ChildBusinessform.Extends1
      }

      return new WebApis.BusinessPayOrderApi().TestSendVideo(Test_Video).then((res)=>{
          if(res.data.ResCode=="1")
          {
            this.$message({
                      showClose: true,
                      message: res.data.Data,
                      type: "success",
                    });
          }
          else
          {
              this.$message({
                      showClose: true,
                      message: res.data.Data,
                      type: "error",
                    });
          }
      }).catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg? e.RspMsg:e.data.Data,
            type: "error"
          });
        });
    },
    OnCancel() {
      this.$emit("clickCancel", {});
    },
    GetBusiness(){
        return new WebApis.BusinessApi()
        .FindAll()
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.Businesses = r;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户数据异常！" + e.RspMsg
              : "获取商户数据异常！",
            type: "error",
          });
        });
    },
    GetScenics()
    {
      let ScenicSearch={};
       return new WebApis.ScenicApi()
            .GetAllScenic(ScenicSearch).then((res)=>{
                if (res.data.Data) {
                  this.Scenics=res.data.Data;
                }
            });
    },
    GetChildBusinessType()
    {
      return new WebApis.BusinessTypeApi().FindAll().then((res)=>{
          if (res.data.Data) {
                  this.BusinessTypes=res.data.Data;
          }
       });
    },
    GetInfo() {

      if (!this.ChildBusiness_Id)
      {
        this.ChildBusinessform.ChildBusinessCode="DFC"+new Date().getTime();
      }

      if (this.ChildBusiness_Id) {
        showLoading(".zj-form-container");

        this.IsUpdate=true;

        let ChildBusinessSearch = {
          ChildBusinessId: this.ChildBusiness_Id,
        };
        return new WebApis.ChildBusinessApi()
          .GetItemByChildBusinessId(ChildBusinessSearch)
          .then((res) => {
            console.log("获取到的ChildBusiness",res.data.Data);
            if (res.data.Data) {
              this.resData = res.data.Data;
              this.ChildBusinessform.ChildBusinessIcon = this.resData.ChildBusinessIcon;
              this.ChildBusinessform.ScenicUUID = this.resData.ScenicId;
              this.ChildBusinessform.ChildBusinessCode = this.resData.ChildBusinessCode;
              this.ChildBusinessform.ChildBusinessName = this.resData.ChildBusinessName;
              this.ChildBusinessform.BusinessCode = this.resData.BusinessCode;
              this.ChildBusinessform.BusinessTypeId = this.resData.BusinessTypeId;
              this.ChildBusinessform.BusinessIcon = this.resData.BusinessIcon;

              this.ChildBusinessform.ContactPerson = this.resData.ContactPerson;
              this.ChildBusinessform.Phone = this.resData.Phone;
              this.ChildBusinessform.Remarks = this.resData.Remarks;
              this.ChildBusinessform.Address = this.resData.Address;
              this.ChildBusinessform.Longitude = this.resData.Longitude;
              this.ChildBusinessform.Latitude = this.resData.Latitude;
              this.ChildBusinessform.BusinessState = this.resData.BusinessState+'';
              this.ChildBusinessform.Extends1 = this.resData.Extends1;
              

              console.log(this.ChildBusinessform);
            }
            
            hideLoading();
          })
          .catch((e) => {
            hideLoading();
            this.$message({
              showClose: true,
              message: e.RspMsg
                ? "获取子商户信息失败!" + e.RspMsg
                : "获取子商户信息失败!",
              type: "error",
            });
            return false;
          });
      }
    },
    SaveData() {
      let ChildBusinessDTO = {
        Id: 0,
        ChildBusinessId: "",
        ChildBusinessCode: this.ChildBusinessform.ChildBusinessCode,
        ChildBusinessName: this.ChildBusinessform.ChildBusinessName,
        ChildBusinessIcon: this.ChildBusinessform.ChildBusinessIcon,
        BusinessCode:this.ChildBusinessform.BusinessCode,
        BusinessTypeId: this.ChildBusinessform.BusinessTypeId,
        ScenicId:this.ChildBusinessform.ScenicUUID,
        ContactPerson:this.ChildBusinessform.ContactPerson,
        Phone:this.ChildBusinessform.Phone,
        Remarks:this.ChildBusinessform.Remarks,
        Address:this.ChildBusinessform.Address,
        Longitude:this.ChildBusinessform.Longitude,
        Latitude:this.ChildBusinessform.Latitude,
        BusinessState:parseInt(this.ChildBusinessform.BusinessState),
        Creater: this.user.UserName,
        CreateTime: new Date(),
        Modifier: this.user.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extends1: this.ChildBusinessform.Extends1,
        Extends2: "",
        Extends3: "",
      };

      if (this.resData) {
        ChildBusinessDTO.Id = this.resData.Id;
        ChildBusinessDTO.ChildBusinessId = this.resData.ChildBusinessId;
        ChildBusinessDTO.Modifier = this.user.UserName;
        ChildBusinessDTO.ModifyTime = new Date();
        ChildBusinessDTO.Validity = 1;
        this.UpdateData(ChildBusinessDTO);
      } else {
        this.InsertData(ChildBusinessDTO);
      }
    },
    InsertData(ChildBusinessInfo) {
      new WebApis.ChildBusinessApi()
        .AddItem(ChildBusinessInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "子商户添加成功!",
              type: "success",
            });

            this.CreaterUser();

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "添加子商户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "子商户添加";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "子商户添加成功" : "添加子商户失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "子商户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          console.log("添加子商户失败",e);
          this.$message({
            showClose: true,
            message: e.RspMsg ? "添加子商户失败！" + e.RspMsg : "添加子商户失败！",
            type: "error",
          });
          return false;
        });
    },
    UpdateData(ChildBusinessInfo) {
      new WebApis.ChildBusinessApi()
        .UpdateItem(ChildBusinessInfo)
        .then((res) => {
          if (res.RspCode == "1") {
            this.$message({
              message: "子商户修改成功!",
              type: "success",
            });

            this.$emit("clickOk", {});
          } else {
            this.$message({
              showClose: true,
              message: "修改子商户失败!" + res.RspMsg,
              type: "error",
            });
            return false;
          }
          this.logInfo.ActionName = "子商户修改";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "子商户修改成功" : "修改子商户失败";
          this.logInfo.ModuleName = "权限管理";
          this.logInfo.PageName = "子商户管理详情页面";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "修改子商户失败！" + e.RspMsg : "修改子商户失败！",
            type: "error",
          });
          return false;
        });
    },
    GetBusinessByBusinessCode(BusinessCode)
    {
      this.Businesses.forEach(function(item){
          if(item.BusinessCode==BusinessCode)
          {
            this.SelectBusiness= item;
            return;
          }
      });
    },
    CreaterUser()
    {
      let user = this.user;
      let OrgInfoSearch={
        OrgCode:this.ChildBusinessform.BusinessCode
      }
     new WebApis.OrgApi(OrgInfoSearch).FindByConditions(OrgInfoSearch).then((res)=>{
        if(res.RspCode=="1")
        {
          var OrgList=res.data.Data;
          if(OrgList && OrgList.length>0)
          {
              var OrgInfo=OrgList[0];
              let UserInfoDTO = {
                Id: 0,
                UserId: "",
                Sex: 1,
                Birthday:  new Date(),
                UserName: this.ChildBusinessform.ChildBusinessName,
                LoginName: this.ChildBusinessform.ChildBusinessCode,
                LoginPwd: "",
                Phone:  this.ChildBusinessform.Phone,
                AllowEdit: 1,
                AllowDelete: 1,
                AllowUseStartTime: this.get_Day(0),
                AllowUseEndTime: this.get_Day(10 * 356),
                PauseUseStartTime: this.get_Day(-2),
                PauseUseEndTime: this.get_Day(-1),
                Description: "",
                Creater: user.UserName,
                CreateTime: new Date(),
                Modifier: user.UserName,
                ModifyTime: new Date(),
                UserEnabled: true,
                Validity: 1,
                Extend1: "",
                Extend2: "",
                IsCanCustom: 0,
                OrgId: OrgInfo.OrgId
              };

              new WebApis.UserApi()
                .InsertUser(UserInfoDTO)
                .then((res) => {
                      console.log("添加子商户返回",res);
                      if (res.RspCode == "1") {
                        UserInfoDTO.UserId = res.data.Data;
                        this.ChoseRole(UserInfoDTO);
                      }
                      else
                      {
                        this.$message({
                          showClose: true,
                          message: "添加用户失败!" + res.RspMsg,
                          type: "error",
                        });
                        return false;
                      }
                      this.logInfo.ActionName = "用户添加";
                      this.logInfo.LogMessage =
                        res.RspCode == "1" ? "用户添加成功" : "添加用户失败";
                      this.logInfo.ModuleName = "统一管理";
                      this.logInfo.PageName = "子商户管理";
                      this.addOperationLog();
                    })
                    .catch((e) => {
                        this.$message({
                          showClose: true,
                          message: e.RspMsg ? "添加用户失败！" + e.RspMsg : "添加用户失败！",
                          type: "error",
                        });
                        return false;
                    });
                  }
                }
      });
    },
    ChoseRole(UserInfoDTO) {
      let user = this.user;
      var LoginUserName = user.UserName;

      var RoleIds=[];
      RoleIds.push("60c0f145-944d-4abc-8e32-43b528029a6f");

      let UserRoleInfoSearch = {
        RoleIds: RoleIds,
        UserId: UserInfoDTO.UserId,
        UserName: UserInfoDTO.UserName,
        LoginName: LoginUserName,
      };

      console.log(UserRoleInfoSearch);

      new WebApis.UserRoleApi()
        .InsertItemList(UserRoleInfoSearch)
        .then((res) => {
          if (res.RspCode != "1") {
            this.$message({
              showClose: true,
              message: "授权失败!",
              type: "error",
            });
          }
          this.logInfo.ActionName = "用户分配角色";
          this.logInfo.LogMessage =
            res.RspCode == "1" ? "用户分配角色成功" : "用户分配角色失败";
          this.logInfo.ModuleName = "统一管理";
          this.logInfo.PageName = "子商户管理";
          this.addOperationLog();
        })
        .catch((e) => {
          this.$message({
            showClose: true,
            message: e.RspMsg ? "权限分配失败!" + e.RspMsg : "权限分配失败!",
            type: "error",
          });
        });
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "-" + tMonth + "-" + tDate;
      return timevalue;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    }
  }
};
</script>
